/**
 * Global Styles - App
 *
 * Any global styles overrides or additional styles can be included in this file
 */
import React from 'react';
import {
  createGlobalStyle,
  Normalize,
  thd,
  th,
  css,
  up,
} from '@smooth-ui/core-sc';
import loriGlobalStyles from '_platform/src/theme/globalStyles';

export const GlobalStylesApp = createGlobalStyle`
  ${loriGlobalStyles}

  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

  html {
    background-color: #F5F5F5;
    font-size: 18px;
  }

  body {
    font-family: "Outfit", sans-serif;
    line-height: 1.6;
  }

  /* Custom CSS here */

  .page-container {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  h1,.h1,h2,.h2,h3,.h3 {
    font-weight: 600;
    font-variation-settings: 'wght' 600;
    color: ${th('primary')};
    line-height: 1.2;
  }

  h1, .h1 {
    font-size: 40px;
    ${up(
      'md',
      css`
        font-size: 52px;
      `
    )}
  }

  h2, .h2 {
    font-size: 30px;
    margin-bottom: 20px;
    ${up(
      'md',
      css`
        font-size: 42px;
      `
    )}
  }

  h3, .h3 {
    font-size: 25px;
    ${up(
      'md',
      css`
        font-size: 32px;
      `
    )}
  }

  h5, .h5 {
    font-size: 18px;
  }

  p {
    font-size: 18px;
  }

  a {
    color: ${thd('defaultLinkColor', 'theme.gray800')};
    &:hover,&:focus {
      text-decoration: none;
    }
  }

  /* Don't wrap emails, phones or other non-wrapping strings */
  .nowrap,
  .date,
  .email,
  .phone {
    white-space: nowrap;
  }

  /* Color text */
  .text--red {
    color: ${thd('danger', '#dc3545')};
  }

  .text--white {
    color: #fff;
  }

  .text--primary {
    color: ${thd('primary', '#867455')};
  }

  .text--secondary {
    color: ${th('secondary')};
  }

  /* Align text */
  .text-center,
  .text-centre,
  .text--center,
  .text--centre {
    text-align: center;
  }
  .text-right,
  .text--right {
    text-align: right;
  }
  .text-left,
  .text--left {
    text-align: left;
  }

  .text-small,
  .text--small {
    font-size: 80%;
  }

  .text-large,
  .text--large {
    font-size: 150%;
  }

  .text-larger,
  .text--larger {
    font-size: 200%;
  }

  .text-normal,
  .text--normal {
    font-weight: normal;
  }
  .text-uppercase,
  .text--uppercase {
    text-transform: uppercase;
  }

  .text--tight {
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  }

  /* Handy spacing classes */
  :root {
    --spacer: 2rem;
  }

  .spacer {
    padding-bottom: 40px;
    padding-top: 40px;
    padding-bottom: var(--spacer);
    padding-top: var(--spacer);
  }
  .spacer--small {
    padding-bottom: 20px;
    padding-top: 20px;
    padding-bottom: calc(var(--spacer) / 2);
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--large {
    padding-bottom: 40px;
    padding-top: 40px;
    padding-bottom: var(--spacer);
    padding-top: var(--spacer);
    ${up(
      'md',
      css`
        padding-bottom: 80px;
        padding-top: 80px;
        padding-bottom: calc(var(--spacer) * 2);
        padding-top: calc(var(--spacer) * 2);
      `
    )}
  }
  .spacer--around {
    padding: 40px;
    padding: var(--spacer);
  }
  .spacer--around--small {
    padding: 20px;
    padding: calc(var(--spacer) / 2);
  }
  .spacer--around--large {
    padding: 80px;
    padding: calc(var(--spacer) * 2);
  }
  .spacer--top {
    padding-top: 40px;
    padding-top: var(--spacer);
  }
  .spacer--bottom {
    padding-bottom: 40px;
    padding-bottom: var(--spacer);
  }
  .spacer--top--small,
  .spacer--small--top {
    padding-top: 20px;
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--bottom--small,
  .spacer--small--bottom {
    padding-bottom: 20px;
    padding-bottom: calc(var(--spacer) / 2);
  }
  .spacer--top--large,
  .spacer--large--top {
    padding-top: 80px;
    padding-top: calc(var(--spacer) * 2);
  }
  .spacer--bottom--large,
  .spacer--large--bottom {
    padding-bottom: 40px;
    padding-bottom: var(--spacer);
    ${up(
      'md',
      css`
        padding-bottom: 80px;
        padding-bottom: calc(var(--spacer) * 2);
      `
    )}
  }

  .Toastify .Toastify__toast--success {
    background: #07bc0c;
  }

  .img--small {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 60%;
    ${up(
      'md',
      css`
        max-width: 100%;
      `
    )}
  }
`;

const StylesApp = () => (
  <React.Fragment>
    <Normalize />
    <GlobalStylesApp />
  </React.Fragment>
);

export default StylesApp;
